import { useEffect, useRef, useState } from "react";
import { testimonials } from "@/mocks/celesteTarot";

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#C9A84C] text-sm"></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const col1 = testimonials.filter((_, i) => i % 3 === 0);
  const col2 = testimonials.filter((_, i) => i % 3 === 1);
  const col3 = testimonials.filter((_, i) => i % 3 === 2);

  const renderCard = (t: typeof testimonials[0], delay: number) => (
    <div
      key={t.id}
      className="bg-white rounded-xl p-6 border border-[#e8dcc8]"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="flex items-center gap-3 mb-4">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0 ${t.color}`}>
          {t.initials}
        </div>
        <div>
          <p className="text-[#1a1208] text-sm font-semibold">{t.name}</p>
          <StarRating count={t.stars} />
        </div>
      </div>
      <p className="text-[#5a4a35] text-sm leading-relaxed">
        &ldquo;{t.text}&rdquo;
      </p>
    </div>
  );

  return (
    <section id="testimonios" className="py-24 md:py-32 bg-[#f5f0e8]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-14">
          <span className="inline-block bg-[#C9A84C]/15 text-[#C9A84C] text-xs tracking-widest uppercase px-4 py-1.5 rounded-full mb-5">
            Testimonios
          </span>
          <h2
            className="text-4xl md:text-5xl font-light text-[#1a1208] leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Lo que dicen<br />
            <span className="italic text-[#C9A84C]">mis clientes</span>
          </h2>
        </div>

        {/* Masonry Grid */}
        <div
          ref={ref}
          className={`grid grid-cols-1 md:grid-cols-3 gap-4 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <div className="flex flex-col gap-4">
            {col1.map((t, i) => renderCard(t, i * 100))}
          </div>
          <div className="flex flex-col gap-4 md:mt-8">
            {col2.map((t, i) => renderCard(t, i * 100 + 150))}
          </div>
          <div className="flex flex-col gap-4">
            {col3.map((t, i) => renderCard(t, i * 100 + 300))}
          </div>
        </div>
      </div>
    </section>
  );
}
